import { render, staticRenderFns } from "./dashboardRight.vue?vue&type=template&id=5768fedc&"
import script from "./dashboardRight.vue?vue&type=script&lang=js&"
export * from "./dashboardRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports